import { MilestoneIcon } from 'lucide-react'

import { VisaBulletinInfoCard } from '@/pages/client-portal/ui/cards/visa-bulletin-info-card/visa-bulletin-info-card'
import { VisaBulletinTrendCard } from '@/pages/client-portal/ui/cards/visa-bulletin-trend-card/visa-bulletin-trend-card'
import { ContentSectionHeader } from '@/pages/client-portal/ui/content-section-header/content-section-header'

import { cn } from '@/lib/utils'

import { useVisaBulletin } from './use-visa-bulletin'

export const VisaBulletin = () => {
  const { visaBulletinData, visaBulletinTrendData, priorityDate } = useVisaBulletin()

  return (
    <div className={cn('mt-[30px]')}>
      <ContentSectionHeader icon={<MilestoneIcon size={24} />} title="Visa Bulletin" />

      <div className={cn('flex flex-col gap-y-5 lg:grid lg:grid-cols-[400px_auto] lg:gap-5', 'mt-5')}>
        <div className={cn('lg:max-w-[400px]')}>
          <VisaBulletinInfoCard visaBulletinData={visaBulletinData} />
        </div>
        <div className={cn('min-w-0')}>
          <VisaBulletinTrendCard visaBulletinTrendData={visaBulletinTrendData} priorityDate={priorityDate} />
        </div>
      </div>
    </div>
  )
}
